import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import BaseStatePlusSprite from "../../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../../engines/gameEngine";
import MathUtil from "../../../../engines/libs/MathUtil";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { MatchMiaiKind } from "../../../define/MatchMiaiKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";
import { OpenOreSpecialCollect } from "../openOreGame/openOreConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MatchMiaiLevelBase extends BasePopUpLayer {

    @property({ type: cc.Node, displayName:'' })
	nodeClose: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeRoleJump: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	nodeEquipShow: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBulletList: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	moveArea: cc.Node = null;

    @property({type:cc.Node,tooltip:"角色节点"})
    nodeRole:cc.Node = null;

    @property({type:cc.Node,tooltip:"可以点击的区域"})
    nodeTouch: cc.Node = null;

    @property({type: cc.Node,tooltip:"黑点Content"})
    nodeBlackList: cc.Node = null;

    @property({type:cc.Node,tooltip:"角色碰撞节点"})
    roleTriggerNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"弹痕"})
    nodeBulletHole: cc.Node = null;

    @property(cc.Node)
    nodeWeapon: cc.Node = null;

    @property(cc.Node)
    nodeButtle: cc.Node = null;

    @property(BaseStatePlusSprite)
    sprRole: BaseStatePlusSprite = null;

    protected roleStartPos: cc.Vec2 = null;
    protected bStartHit = false;

    protected curSoundId: number = null;

    /** 当前装备打中次数 */
    protected curEquipHitCount = 0;
    /** 胜利需要击中的次数 */
    protected winNeedHitCount = 0;
    /** 当前装备一击射出的子弹数 */
    protected hitBulletCount = 0;
    /** 枪的csv数据 */
    protected csvEquip: any = null;

    start(){

        this.initLayer();
       
        this.nodeTouch.on('touchstart',this.onTouchStart,this);
        O1HD.on(MessageEventKind.EventName.MATCH_MIAI_SWITCH_EQUIP, this.showEuqipUI, this);
    }

    initLayer() {
        this.setGameState(false);
        this.roleStartPos = this.nodeRole.getPosition();
        this.nodeBulletHole.active = false;
        this.nodeButtle.active = false;
    }

    resetData() {
        this.setGameState(false);
        this.bStartHit = false;
        this.nodeRole.setPosition(this.roleStartPos);
        this.nodeBlackList.removeAllChildren();
        this.nodeBulletList.removeAllChildren();
    }

    setGameState(enable: boolean) {
        
    }

    stopSound() {
        if(this.curSoundId){
            O1HD.getManagers().soundMgr.stopSound(this.curSoundId);
            this.curSoundId = null;
        }
    }

    playSound(sound: string): Promise<number> {
        return new Promise((resolve)=> {
            this.stopSound();
            O1HD.getManagers().soundMgr.playSound(sound, (clip)=> {
                resolve(clip.duration);
            }).then((id)=> {
                this.curSoundId = id;
            });
        });
    }

    isGameing() {
        return this.bStartHit;
    }

    onTouchStart(e:cc.Event.EventTouch){
        if (!this.bStartHit) {
            return;
        }

        let worldPos:cc.Vec2 = e.getLocation();
        this.shotOneBullet(worldPos);
    }

    showEuqipUI() {
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        let csvInfo = this.csvEquip = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MATCH_MIAI, matchMiaiData.curUseEquip);
        if (!csvInfo) {
            console.error(`未找到此装备数据 id = ` + matchMiaiData.curUseEquip);
            return;
        }

        // 弹痕
        let bulletHoleSpr = this.nodeBulletHole.getComponent(cc.Sprite);
        let bullet_hole_icon = 'res/equip/' + csvInfo.bullet_hole_icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.matchMiaiBundle).load(bullet_hole_icon,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"showEuqipUI");
                return;
            }
            bulletHoleSpr.spriteFrame = spr;
        });

        // 枪
        let equipPath = 'res/equip/'  + csvInfo.icon;
        let gwidth = this.nodeEquipShow.node.width;
        let gheight = this.nodeEquipShow.node.height;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.matchMiaiBundle).load(equipPath,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"showEuqipUI");
                return;
            }
            this.nodeEquipShow.spriteFrame = spr;
            let scale = Math.min(gwidth / this.nodeEquipShow.node.width, gheight / this.nodeEquipShow.node.height);
            this.nodeEquipShow.node.scale = scale;    
        });

        // 子弹
        let bulletIcon: string = null;
        let special_type = csvInfo.special_type;
        if (utilsModel.isValidNumberValue(special_type)) {
            switch(special_type) {
                case MatchMiaiKind.SpecialEquipType.CUPID_ARROW: {
                    bulletIcon = this.csvEquip.bullet_icon;
                }
                break;
            }
        }
        if (bulletIcon) {
            let bulletIconPath = 'res/equip/' + bulletIcon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.matchMiaiBundle).load(bulletIconPath,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                if(err){
                    console.error(err,"showEuqipUI");
                    return;
                }
                this.nodeButtle.getComponent(cc.Sprite).spriteFrame = spr;
            });
        }
        
        this.curEquipHitCount = 0;
        if (utilsModel.isValidNumberValue(csvInfo.win_hit_count)) {
            this.winNeedHitCount = Number(csvInfo.win_hit_count);
        } else {
            this.winNeedHitCount = null;
        }
        this.hitBulletCount = Number(csvInfo.bullet_count);
    }

    //发射一个子弹
    shotOneBullet(targetPos:cc.Vec2){
        let onePos = this.nodeWeapon.convertToWorldSpaceAR(cc.v2());
        // let angle = MathUtil.getAngle2(onePos, targetPos) - 90;
        // this.nodeWeapon.angle = angle;

        let sPos = this.nodeBulletList.convertToNodeSpaceAR(onePos);
        let ePos = this.nodeBulletList.convertToNodeSpaceAR(targetPos);

        const space = -10;
        let posList = [];
        let gheight = this.nodeBulletHole.height;
        let targetPosNode = this.nodeBlackList.convertToNodeSpaceAR(targetPos);
        switch(this.hitBulletCount) {
            case 1: {
                posList.push(targetPosNode);
            }
            break;
            case 2: {
                posList.push(
                    cc.v2(targetPosNode.x, targetPosNode.y + (gheight+space)/2)
                    , cc.v2(targetPosNode.x, targetPosNode.y - (gheight+space)/2)
                );
            }
            break;
            case 3: {
                posList.push(
                    cc.v2(targetPosNode.x, targetPosNode.y + (gheight+space))
                    , cc.v2(targetPosNode.x, targetPosNode.y)
                    , cc.v2(targetPosNode.x, targetPosNode.y - (gheight+space))
                );
            }
            break;
        }

        let iCount = 0;
        let speed = 50000;
        const cSpaceTime = 0.04;
        let idx = 0;
        let needTime = 0; 

        let bShowBullet = false;
        let eBezierPos: cc.Vec2 = null;
        let special_type = this.csvEquip.special_type;
        if (utilsModel.isValidNumberValue(special_type)) {
            switch(special_type) {
                case MatchMiaiKind.SpecialEquipType.CUPID_ARROW: {
                    bShowBullet = true;
                    speed = 2000;
                    needTime = ePos.sub(sPos).mag() / speed;

                    let rolePos = this.sprRole.node.getPosition();
                    rolePos = this.sprRole.node.convertToWorldSpaceAR(
                        cc.v2(rolePos.x, rolePos.y + (this.sprRole.node.height/2 * this.sprRole.node.scaleY)));
                    let eRolePos = this.nodeBulletList.convertToNodeSpaceAR(rolePos);
                    needTime += eRolePos.sub(ePos).mag() / speed;
                    eBezierPos = eRolePos;
                }
                break;
            }
        }
        
        for (let o of posList) {
            let nodeButtle = cc.instantiate(this.nodeButtle);
            nodeButtle.active = true;
            nodeButtle.setPosition(sPos);
            nodeButtle.angle = MathUtil.getAngle2(sPos, ePos) - 90;
            this.nodeBulletList.addChild(nodeButtle);

            nodeButtle.getComponent(cc.Sprite).enabled = bShowBullet;

            let tweenCall = cc.tween().call(()=>{
                nodeButtle.destroy();
                // 子弹到达 判断是否需要做动作
                if (!eBezierPos) {
                    this.showBulletHole(o);
                }
                if (iCount == 0) {
                    this.checkIsInRole(targetPos);
                }
                iCount++;
            });

            let tweenStart = cc.tween(nodeButtle)
            .delay(cSpaceTime * idx);

            if (eBezierPos) {
                let lPos = sPos;

                tweenStart.call(()=> {
                    O1HD.getManagers().soundMgr.playSound("match_miai_equip_arrow").then();
                })
                tweenStart.parallel(
                    cc.tween().bezierTo(needTime, sPos, ePos, eBezierPos)
                    , cc.tween().to(needTime, {opacity: 255}
                        , {
                        onUpdate: (current: any, percent: number) => {
                            let ctP = nodeButtle.getPosition();
                            this.adjustDirection(nodeButtle, lPos, ctP);
                            lPos = ctP;
                        }}
                    )
                )
                .then(tweenCall).start();
            } else {
                tweenStart.call(()=> {
                    O1HD.getManagers().soundMgr.playSound("match_shot").then();
                })
                tweenStart.to(needTime,{x: ePos.x, y: ePos.y}).then(tweenCall).start();
            }
            idx++;
        }
    }

    /**
     * 调整子弹方向
     * @param start 
     * @param end 
     */
    adjustDirection(nodeButtle: cc.Node, start: cc.Vec2, end: cc.Vec2) {
        let angle = MathUtil.getAngle2(start, end);
        nodeButtle.angle = angle -90;
    }

    showCloseBtn(visible: boolean) {
        this.nodeClose.active = visible;
    }

    checkIsInRole(worldPos:cc.Vec2){

    }

    setHitState(enable: boolean) {
        this.bStartHit = enable;
    }

    showEquipList(bSpecial: boolean) {
        this.setHitState(false);

        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MatchMiaiWeaponSelect
            , null
            , {
                parent: this
                , bSpecial: bSpecial
                , resumeHit: ()=> {
                    this.setHitState(true);
                }
            }
        );
    }

    showBulletHole(pos: cc.Vec2) {
        this.createBulletHole([pos]);
    }

    createBulletHole(posList: cc.Vec2[]) {
        for (let o of posList) {
            let nodeItem = cc.instantiate(this.nodeBulletHole);
            nodeItem.active = true;
            
            this.nodeBlackList.addChild(nodeItem);
            nodeItem.setPosition(o);
        }
    }

    openBuyEquipLayer() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MatchMiaiBuyEquipLayer
        );
    }

    async openGetGoodsLayer(
        addGold: number
        , addExp: number
        , addGoodsList: any
    ) {
        return new Promise<void> (resolve=> {
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.EventGetGoodsLayer
                , null
                , {
                    parent: this
                    , addGold: addGold
                    , addExp: addExp
                    , addGoodsList: addGoodsList
                    , onComplete: ()=> {
                        resolve();
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        });
    }

    onPushGoods(id: number, count: number) {
        let t = OpenOreSpecialCollect;
        let nidx = t.indexOf(id);
        let gameData = NormalGameManager._instance.getGameData();
        if (nidx != -1) {
            if (!gameData.nvWaStore[nidx]) {
                gameData.nvWaStore[nidx] = true;
                
                NormalGameManager._instance.writeGameData();
                if (count > 1) {
                    NormalGameManager._instance.onPushGoods(id, count-1);    
                }
            } else {
                NormalGameManager._instance.onPushGoods(id, count);
            }
        } else {
            NormalGameManager._instance.onPushGoods(id, count);
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.stopAllEffects();
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (this.isGameing()) {
            this.exitHint();
        } else {
            this.closeGame();
        }
    }

    closeGame() {
        this.destroyNode();
        this._carryData.parent.destroyNode();
    }

    exitHint() {
        ModelDialogLayer.show(' 确认要退出吗？', null, ()=> {
            this.closeGame();
        }
        , '确认退出'
        , '我再试试'
        );
    }
}
